module.exports = __webpack_public_path__ + "img/mbbanner.a90a4c42.png";